'use client';

import { memo } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { LocalShipping, Scale } from '@mui/icons-material';
import { themeColors } from '../../../theme/theme';
import { useTranslation } from '@/kit/useTranslation';

/**
 * Parcel details section (type, weight)
 */
const ParcelDetailsSection = memo(({ itemType, weight }) => {
  const { t } = useTranslation();
  const displayType = Array.isArray(itemType)
    ? itemType.join(', ')
    : itemType || t('bookingDetails.package');
  const displayWeight = weight ? `${weight} kg` : t('bookingDetails.na');

  return (
    <Stack direction="row" spacing={3} alignItems="center">
      <Stack direction="row" spacing={0.8} alignItems="center">
        <LocalShipping sx={{ fontSize: 16, color: themeColors.primaryColor, opacity: 0.7 }} />
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: 10, display: 'block', lineHeight: 1.2 }}
          >
            {t('bookingDetails.type')}
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
            {displayType}
          </Typography>
        </Box>
      </Stack>

      <Stack direction="row" spacing={0.8} alignItems="center">
        <Scale sx={{ fontSize: 16, color: '#ff9800', opacity: 0.7 }} />
        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ fontSize: 10, display: 'block', lineHeight: 1.2 }}
          >
            {t('bookingDetails.weight')}
          </Typography>
          <Typography variant="body2" fontWeight={600} sx={{ fontSize: 13 }}>
            {displayWeight}
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
});

ParcelDetailsSection.displayName = 'ParcelDetailsSection';

export default ParcelDetailsSection;
